import { create } from "zustand";
import { useFetchTargetSlice } from "../slices/TargetSlices/fetchTargetSlices";
import { useUpdateTargetSlice } from "../slices/TargetSlices/updateTargetSlice";
import { useUploadTargetSlice } from "../slices/TargetSlices/uploadTargetSlice";

interface TargetInterface
  extends ReturnType<typeof useFetchTargetSlice>,
    ReturnType<typeof useUpdateTargetSlice>,
    ReturnType<typeof useUploadTargetSlice> {}

export const TargetStore = create<TargetInterface>((...a) => ({
  ...useFetchTargetSlice(...a),
  ...useUploadTargetSlice(...a),
  ...useUpdateTargetSlice(...a),
}));
